var map = {
	"./default": [
		58,
		9,
		4,
		5,
		7
	],
	"./default/": [
		58,
		9,
		4,
		5,
		7
	],
	"./default/config": [
		111,
		3,
		50
	],
	"./default/config.json": [
		111,
		3,
		50
	],
	"./default/index": [
		58,
		9,
		4,
		5,
		7
	],
	"./default/index.tsx": [
		58,
		9,
		4,
		5,
		7
	],
	"./empty": [
		61,
		9,
		4,
		8,
		5,
		9
	],
	"./empty/": [
		61,
		9,
		4,
		8,
		5,
		9
	],
	"./empty/assets/background.svg": [
		148,
		7,
		58
	],
	"./empty/config": [
		106,
		3,
		51
	],
	"./empty/config.json": [
		106,
		3,
		51
	],
	"./empty/index": [
		61,
		9,
		4,
		8,
		5,
		9
	],
	"./empty/index.tsx": [
		61,
		9,
		4,
		8,
		5,
		9
	]
};
function webpackAsyncContext(req) {
	if(!__webpack_require__.o(map, req)) {
		return Promise.resolve().then(function() {
			var e = new Error("Cannot find module '" + req + "'");
			e.code = 'MODULE_NOT_FOUND';
			throw e;
		});
	}

	var ids = map[req], id = ids[0];
	return Promise.all(ids.slice(2).map(__webpack_require__.e)).then(function() {
		return __webpack_require__.t(id, ids[1])
	});
}
webpackAsyncContext.keys = function webpackAsyncContextKeys() {
	return Object.keys(map);
};
webpackAsyncContext.id = 123;
module.exports = webpackAsyncContext;